import React from 'react';



class NewStaticTextBox extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            editMode: false,
            value:this.props.value,
            updated:false
        }
    }

    static getDerivedStateFromProps(props, state){
        if(state.value !== props.value && state.updated === false ){
            return {
                value:props.value,
                updated:true
            }
        }
    }

    handleEditMode = () =>{
        this.setState({
            editMode:true
        });
    }


    handleApply =()=>{

        if(this.props.required === true){
            if(this.props.value === null){
                this.props.onError(true,this.props.label+" can not be empty",'error');
                return false;
            }

            if(this.props.value.length === 0){
                this.props.onError(true,this.props.label+" can not be empty",'error');
                return false;
            }
        }

        this.props.UpdateData({field:this.props.field,value:this.state.value});

        this.setState({
            editMode:false
        });
    }

    render() {

    
        
        return <div>
            {this.state.editMode === false ? (
            <div className="profrm-row">
            <label>{this.props.label}</label>
            <textarea style={{width:'98%', backgroundColor:'rgba(202, 201, 201, 0.21)', fontSize:'14px' }}  readOnly={true} onChange={this.props.onChange} value={this.props.value}    ></textarea>
         
            <span onClick={()=>this.handleEditMode()}></span>
            <div style={{clear:'both'}}/>
            {this.props.review === true ? <i><small style={{color:'red'}}>In review</small></i>:<i><small >&nbsp;</small></i>}
            
          </div>
            
            ) : (
                <div className="profrm-row active">
                    <label>{this.props.label}</label>
                    <textarea style={{width:'98%'}} onChange={(e)=>this.setState({value:e.target.value})} value={this.state.value}></textarea>
                    <span onClick={()=>this.handleApply()} style={{bottom:0}}></span>
                    <div style={{clear:'both'}}/>                        
                  </div>           
              
            )}
        </div>
    }
}

NewStaticTextBox.defaultProps = {
    type:'text',
    review:false,
}

export default NewStaticTextBox;